import React from 'react';
import WhiteTextButton from '@components/common/WhiteTextButton';

export default function ContactAndRequestButtons(): React.JSX.Element {
  return (
    <div className="flex flex-col space-y-4 max-md:space-y-3">
      <WhiteTextButton href="https://renovefudosan.com/lp/inquiry_check/" label="お問い合わせ" handleClick={() => {}} />
      <WhiteTextButton href="https://renovefudosan.com/request/" label="資料請求" handleClick={() => {}} />
    </div>
  );
}
